import http from '@/utils/http'

export function getHomeworks(params){
    return http.get('/homeworks',{params})
}
export function getStudentHomeworks(params){
    return http.get('/studentHomeworks',{params})
}
export function addHomeworks(data){
    return http.post('/homeworks',data)
}
export function getHomeworksDetail(id){
    return http.get(`/homeworks/${id}`)
}
export function putHomeworks(id,data){
    return http.put(`/homeworks/${id}`,data)
}
export function editHomeworkState(id){
    return http.put(`/editHomeworkState/${id}`)
}
export function getCountBadHomework(){
    return http.get('/getCountBadHomework')
}
export function putCopyHomeworks(id,data){
    return http.put(`/homeworks/${id}/copy`,data)
}
export function deleteHomeworks(id){
    return http.delete(`/homeworks/${id}`)
}
export function getHomeworksDistributionRequest(id,data){
    return http.post(`/homeworks/${id}/distribution_request`,data)
}